// extracted by mini-css-extract-plugin
module.exports = {"info":"template-service-not-available_info__3PVf9","infoTitle":"template-service-not-available_infoTitle__28TUL","infoDesc":"template-service-not-available_infoDesc__1bMCD"};